import { Action } from '@ngrx/store';

import { User } from '../../shared/models/user';
import { LoginForm, SmsForm } from '../models/login.model';

export const LOGIN = '[Login] Login';
export const LOGIN_SUCCESS = '[Login] Login Success';
export const LOGIN_FAILURE = '[Login] Login Failure';
export const LOGIN_REDIRECT = '[Login] Login Redirect';

export const LOGOUT = '[Login] Logout';
export const LOGOUT_SUCCESS = '[Login] Logout Success';
export const LOGOUT_FAILURE = '[Login] Logout Failure';

export const SELECT_METHOD = '[Login] Select Method';
export const SELECT_METHOD_SUCCESS = '[Login] Select Method Success';
export const SELECT_METHOD_FAILURE = '[Login] Select Method Failure';

export const LOGIN_SMS = '[Login] Login SMS';
export const LOGIN_SMS_SUCCESS = '[Login] Login SMS Success';
export const LOGIN_SMS_FAILURE = '[Login] Login SMS Failure';

export const CAPTCHA_CHECK_SUCCESS = '[Login] Captcha Check Success';
export const CAPTCHA_EXPIRE = '[Login] Captcha EXPIRE';
export const CAPTCHA_INIT_SUCCESS = '[Login] Captcha Init Success';
export const CAPTCHA_INIT_FAILURE = '[Login] Captcha Init Failure';

export const CAPTCHA_FAILURE = '[Login] Captcha Failure';
export const CAPTCHA_SUCCESS = '[Login] Captcha Success';
export const ERROR = '[Login] Error';
export const CODE_EXPIRED = '[Login] Sms Code Expired';


export class Login implements Action {
  readonly type = LOGIN;

  constructor(public payload: LoginForm) {
  }
}

export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;

  constructor(public payload: { user: User }) {
  }
}

export class LoginFailure implements Action {
  readonly type = LOGIN_FAILURE;

  constructor(public payload: any) {
  }
}

export class LoginRedirect implements Action {
  readonly type = LOGIN_REDIRECT;
}

export class Logout implements Action {
  readonly type = LOGOUT;
}

export class LogoutSuccess implements Action {
  readonly type = LOGOUT_SUCCESS;
}

export class LogoutFailure implements Action {
  readonly type = LOGOUT_FAILURE;

  constructor(public payload: any) {
  }
}

export class SelectMethod implements Action {
  readonly type = SELECT_METHOD;

  constructor(public payload: string) {
  }
}
export class SelectMethodSuccess implements Action {
  readonly type = SELECT_METHOD_SUCCESS;

  constructor(public payload: string) {
  }
}
export class SelectMethodFailure implements Action {
  readonly type = SELECT_METHOD_FAILURE;

  constructor(public payload?: any) {
  }
}

export class LoginSms implements Action {
  readonly type = LOGIN_SMS;

  constructor(public payload: SmsForm) {
  }
}

export class LoginSmsSuccess implements Action {
  readonly type = LOGIN_SMS_SUCCESS;

  constructor(public payload: { user: User }) {
  }
}

export class LoginSmsFailure implements Action {
  readonly type = LOGIN_SMS_FAILURE;

  constructor(public payload: any) {
  }
}

export class CaptchaCheckSuccess implements Action {
  readonly type = CAPTCHA_CHECK_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CaptchaExpire implements Action {
  readonly type = CAPTCHA_EXPIRE;
}

export class CaptchaInitSuccess implements Action {
  readonly type = CAPTCHA_INIT_SUCCESS;

  constructor(public payload: string) {
  }
}

export class CaptchaInitFailure implements Action {
  readonly type = CAPTCHA_INIT_FAILURE;

  constructor(public payload: any) {
  }
}

export class CaptchaSuccess implements Action {
  readonly type = CAPTCHA_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CaptchaFailure implements Action {
  readonly type = CAPTCHA_FAILURE;

  constructor(public payload: any) {
  }
}

export class FormError implements Action {
  readonly type = ERROR;

  constructor(public payload: any) {
  }
}

export class CodeExpired implements Action {
  readonly type = CODE_EXPIRED;
}


export type Actions =
  | Login
  | LoginSuccess
  | LoginFailure
  | LoginRedirect
  | Logout
  | SelectMethod
  | LoginSms
  | LoginSmsSuccess
  | LoginSmsFailure
  | CaptchaCheckSuccess
  | CaptchaExpire
  | CaptchaInitSuccess
  | CaptchaInitFailure
  | CaptchaSuccess
  | CaptchaFailure
  | FormError
  | CodeExpired
  | SelectMethodSuccess
  | SelectMethodFailure;




// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/actions/login.ts